import PrescriberList from "./PrescriberList";
export default PrescriberList;
